import { useEffect, useState } from "react";
import {
  ContentSafetySettings,
  initialModerationSettings,
  ModerationFlag,
} from "../../components/adminDashboard/ContentSafety";

type Props = {
  contentSafety: {
    sexual: boolean;
    hate: boolean;
    harassment: boolean;
    selfHarm: boolean;
    violence: boolean;
  };
  setContentSafety: React.Dispatch<
    React.SetStateAction<{
      sexual: boolean;
      hate: boolean;
      harassment: boolean;
      selfHarm: boolean;
      violence: boolean;
    }>
  >;
};

function AdminContentSafetySettingsContainer({ contentSafety, setContentSafety }: Props) {
  const moderationFlags: ModerationFlag[] = initialModerationSettings.map((flag) => ({
    ...flag,
    enabled: contentSafety[flag.id as keyof typeof contentSafety] ?? false,
  }));

  return (
    <ContentSafetySettings
      moderationSettings={moderationFlags}
      onSettingsChange={(newFlags) => {
        const mapped = {
          sexual: newFlags.find((f) => f.id === "sexual")?.enabled ?? false,
          hate: newFlags.find((f) => f.id === "hate")?.enabled ?? false,
          harassment: newFlags.find((f) => f.id === "harassment")?.enabled ?? false,
          selfHarm: newFlags.find((f) => f.id === "selfHarm")?.enabled ?? false,
          violence: newFlags.find((f) => f.id === "violence")?.enabled ?? false,
        };

        setContentSafety(mapped);
      }}
    />
  );
}

export default AdminContentSafetySettingsContainer;
